/**
 * @generated SignedSource<<562465ef8265d5d23e2424c599193d33>>
 * @relayHash b2d7e70e45866cb05b2662c2d7cfed78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 22faaff69843483ef60d4de279304a4f15d34d081305f2df728cf86333831fa7

import type { ConcreteRequest } from 'relay-runtime';
export type SettingsMenuItemInput = {
  menuId: string;
  visible: boolean;
};
export type SettingsDisplayPropertyInput = {
  key: string;
  value: string;
};
export type useNavSettingsServiceMutation$variables = {
  entityAri: string;
  ownerAri: string;
  pageSizeValue: number;
  properties?: ReadonlyArray<SettingsDisplayPropertyInput | null> | null;
  sidebar?: ReadonlyArray<SettingsMenuItemInput | null> | null;
};
export type useNavSettingsServiceMutation$data = {
  readonly settings_updateNavigationCustomisation: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null;
        readonly visible: boolean | null;
      } | null> | null;
    } | null;
  } | null;
};
export type useNavSettingsServiceMutation = {
  response: useNavSettingsServiceMutation$data;
  variables: useNavSettingsServiceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSizeValue"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "properties"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sidebar"
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
      },
      {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
      },
      {
        "kind": "Variable",
        "name": "properties",
        "variableName": "properties"
      },
      {
        "kind": "Variable",
        "name": "sidebar",
        "variableName": "sidebar"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "pageSizeValue"
  }
],
v7 = {
  "args": (v6/*: any*/),
  "concreteType": "SettingsMenuItemConnection",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsMenuItem",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "menuId"
        },
        {
          "kind": "ScalarField",
          "name": "visible"
        }
      ]
    }
  ]
},
v8 = {
  "args": (v6/*: any*/),
  "concreteType": "SettingsDisplayPropertyConnection",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsDisplayProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useNavSettingsServiceMutation",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useNavSettingsServiceMutation",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "22faaff69843483ef60d4de279304a4f15d34d081305f2df728cf86333831fa7",
    "metadata": {},
    "name": "useNavSettingsServiceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "33eadcae8875ac6ec53a5b1340297431";

export default node;
